import React from 'react';
import { Box, Button, LinearProgress, Typography } from '@mui/material';
import logo from '../../../assets/img/logo.svg';
import useAuthentication from '../../../hooks/authentication.hook';
import { MOCK, TOTAL_STEPS } from './tokens';

/**
 * Logo + progress stepper + account block. `step` is 1-based; pass 0 (or omit)
 * on the signup, which is the entry door: it shows neither the stepper nor the
 * account block. The exit logs the user out; `exitLabel` renames it.
 */
export default function OnbTopBar({ step, exitLabel = 'Sair' }) {
    const { logout } = useAuthentication();

    const showStepper = Boolean(step);
    const showAccount = Boolean(step);

    // Desktop keeps the stepper inline with the logo; mobile drops it to a full
    // width row underneath, where there is no room to share the line.
    const stepper = (
        <>
            <LinearProgress
                variant="determinate"
                value={(step / TOTAL_STEPS) * 100}
                sx={{
                    flex: 1,
                    height: { xs: 5, md: 6 },
                    borderRadius: 3,
                    backgroundColor: 'rgba(0,0,0,0.08)',
                    '& .MuiLinearProgress-bar': { borderRadius: 3 }
                }}
            />
            <Typography variant="caption" sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                {step}/{TOTAL_STEPS}
            </Typography>
        </>
    );

    return (
        <Box sx={{ position: 'relative', zIndex: 2, px: { xs: 2.5, md: 5 }, py: { xs: 2, md: 3 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: { xs: 2, md: 4 } }}>
                <Box component="img" src={logo} alt="Mobilizei" sx={{ height: { xs: 22, md: 28 }, display: 'block' }} />

                {showStepper && (
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, flex: 1, maxWidth: 480, alignItems: 'center', gap: 1.5 }}>
                        {stepper}
                    </Box>
                )}

                {showAccount && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Button
                            variant="text"
                            color="secondary"
                            onClick={logout}
                            sx={{ flex: 'none', whiteSpace: 'nowrap', px: { xs: 1, md: 3.75 } }}
                        >
                            {exitLabel}
                        </Button>
                    </Box>
                )}
            </Box>

            {showStepper && (
                <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1.25, mt: 1.75 }}>
                    {stepper}
                </Box>
            )}
        </Box>
    );
}
